<template>
    <div class="user-add-view">
        <Toast/>
        <h1>Edytuj dane użytkownika</h1>
        <div class="user-form">
            <VeeForm v-if="loaded" @submit="saveUser" v-slot="{ isSubmitting }" class="form">
                <div class="field">
                    <p>Rola</p>
                    <EonDropdown width="250" :items="role" itemLabel="name" itemValue="code"
                                 placeholder="Rola" name="systemRole" v-model="user.systemRole"/>
                </div>
                <div class="field">
                    <p>Imię i nazwisko</p>
                    <EonInputText width="250" label="Imię i nazwisko" name="fullName"
                                  v-model="user.fullName" rules="required"/>
                </div>
                <div class="field">
                    <p>E-mail</p>
                    <EonInputText width="250" label="E-mail" name="email"
                                  v-model="user.email" rules="required|email"/>
                </div>
                <div class="buttons">
                    <EonButton label="Zapisz" type="submit" :disabled="isSubmitting"/>
                    <EonOutlinedButton label="Anuluj" type="button" @click="goBack"/>
                </div>
            </VeeForm>
            <div class="user-info" v-if="loaded">
                <div class="flex flex-column gap-3 mb-5">
                    <EonCheckbox label="Zgoda na powiadomienia email" name="emailNotificationAgreement"
                                 class="checkbox-alignment flex" disabled
                                 v-model="user.emailNotificationAgreement" />
                    <EonCheckbox label="Zgoda na powiadomienia SMS" name="smsNotificationAgreement"
                                 class="checkbox-alignment flex" disabled
                                 v-model="user.smsNotificationAgreement" />
                </div>
                <h2 v-if="addresses.length > 0" class="user-info-address-header">
                    Lista adresów użytkownika
                </h2>
                <ul v-if="addresses.length > 0" class="user-info-addresses-list">
                    <li v-for="address in addresses" :key="address.id">
                        {{ address.details }}
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import Toast from "primevue/toast";
    import {Form as VeeForm} from "vee-validate";
    import {
        editUser,
        getUser,
        getArea,
        getAddressesById,
    } from "@/swagger/vue-api-client";
    import EonButton from "@/components/form/EonButton";
    import EonInputText from "@/components/form/EonInputText";
    import EonDropdown from "@/components/form/EonDropdown";
    import EonInputNumber from "@/components/form/EonInputNumber";
    import EonOutlinedButton from "@/components/form/EonOutlinedButton";
    import {StatusCodes} from "@/utils/StatusCodes";
    import CustomPassword from "@/components/form/CustomPassword";
    import CustomInputText from "@/components/form/CustomInputText";
    import EonCheckbox from "@/components/form/EonCheckbox";

    export default {
        name: "UserFormView",

        components: {
            EonOutlinedButton,
            CustomInputText,
            CustomPassword,
            Toast,
            VeeForm,
            EonButton,
            EonInputText,
            EonDropdown,
            EonInputNumber,
            EonCheckbox,
        },

        props: {
            value: {},
        },

        data() {
            return {
                ar: null,
                user: {
                    id: null,
                    systemRole: null,
                    area: null,
                    fullName: null,
                    email: null,
                    phone: null,
                    emailNotificationAgreement: null,
                    smsNotificationAgreement: null,
                },
                loaded: false,
                role: [
                    {name: "Mistrz prac planowych", code: "DISPATCHER"},
                    {name: "Administrator", code: "ADMIN"},
                    {name: "Call Center", code: "CALLCENTER"},
                    {name: "Akceptujący", code: "ACCEPTER"},
                ],
                addresses: [],
            };
        },

        beforeMount() {
            if (this.$route.params.id) {
                getUser({id: this.$route.params.id}).then((response) => {
                    this.user = response.data;
                    if (!this.user.area) {
                        this.user.area = {id: null};
                    }
                    this.loaded = true;
                });
                getAddressesById({id: this.$route.params.id}).then((response) => {
                    console.log(response.data);
                    this.addresses = response.data;
                });
            } else {
                this.loaded = true;
            }
        },

        methods: {
            async saveUser() {
                if (this.user.area && this.user.area.id) {
                    const areaResponse = await getArea({id: this.user.area.id});
                    this.user.area = areaResponse.data;
                }
                editUser({body: this.user, id: this.user.id}).then(() => {
                    this.$toast.add({
                        severity: "success",
                        summary: "Zapisano dane użytkownika",
                        life: 2000,
                    });
                })
                    .catch((error) => {
                        if (error.response.status === StatusCodes.FORBIDDEN) {
                            this.$toast.add({
                                severity: "error",
                                summary: "Nie masz wystarczających uprawnień",
                                life: 2000,
                            });
                        } else {
                            this.$toast.add({
                                severity: "error",
                                summary: "Wystąpił nieoczekiwany błąd",
                                life: 2000,
                            });
                        }
                    });
                // eslint-disable-next-line no-promise-executor-return
                await new Promise((r) => setTimeout(r, 1000));
                this.goBack();
            },
            goBack() {
                this.$router.go(-1);
            },
        },
    };
</script>

<style lang="less">
.user-add-view {
    @import "../assets/less/edit-view.less";
    display: flex;
    flex-direction: column;
    .user-form {
        display: flex;
        gap: 10px;
        margin-left: 100px;
        gap: 3rem;
        justify-content: space-evenly;
        max-width: 1920px;
        .user-info {
            .user-info-address-header {
                text-align: left;
            }
            .user-info-addresses-list {
                list-style: none;
                display: flex;
                flex-direction: column;
                gap: 1rem;
                max-height: 200px;
                padding-right: 2rem;
                padding-left: 0;
                overflow-y: auto;
                li {
                    text-align: left;
                }
            }
            .checkbox-alignment {
                .eon-checkbox-off {
                    display: flex;
                    align-items: center;
                }
            }
        }
        .buttons {
            justify-content: end;
            margin-top: 2rem;
        }
        @media screen and (max-width: 1000px) {
            flex-direction: column;
        }
    }
}
</style>
